import { applySnapshot, getSnapshot, types as t } from 'mobx-state-tree';

const PermissionTypeModel = t.model('PermissionTypeModel', {
  id: t.number,
  name: t.string,
  description: t.string,
});

export const PermissionsTypeModel = t
  .model('PermissionsTypeModel', {
    list: t.array(PermissionTypeModel),
  })
  .actions((self) => {
    let initialState = {};
    return {
      afterCreate() {
        initialState = getSnapshot(self);
      },
      reset() {
        applySnapshot(self, initialState);
      },
    };
  });

export default PermissionsTypeModel;
